export const elipsize = (text) => {
    return text?.slice(0,150)+"...";
}

export const shotTitle = (text) => {
    return text?.slice(0,50)+"...";
}